import { render, staticRenderFns } from "./Codebox.vue?vue&type=template&id=ad1a5fd8&scoped=true&"
import script from "./Codebox.vue?vue&type=script&lang=js&"
export * from "./Codebox.vue?vue&type=script&lang=js&"
import style0 from "./Codebox.vue?vue&type=style&index=0&id=ad1a5fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1a5fd8",
  null
  
)

export default component.exports